<div class="popover-container">
  <div class="pop-over" [innerHtml]="popoverText"></div>
</div>